import { LitElement, html, css } from 'lit-element';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
// remove root
// rework nav to be /_/ orsomething

export class SportContext extends LitElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                }
                tmn-select {
                    width: 160px;
                }
            `,
        ];
    }

    static get properties() {
        return {
            sport: {
                type: String,
            },
            sportOptions: {
                type: Array,
            },
        };
    }

    render() {
        // const canAccessRootViews = this.authorizations.includes(CAN_ACCESS_ROOT_VIEWS);
        // if (canAccessRootViews) {
        //     return this.renderSports();
        // }
        const { sport, sportOptions } = this;
        if (sportOptions?.length < 2) {
            return null;
        }
        return this.renderSports();
    }

    renderSports() {
        const { sport, sportOptions } = this;
        const selection = sportOptions.filter((s) => s.name === sport);
        return html`
            <tmn-select
                .placeholder=${'Select sport'}
                @tmn-selections-changed=${this.handleSelectChanged}
                .selections=${selection}
                .data=${sportOptions}
                nosearch></tmn-select>
        `;
    }

    handleSelectChanged(e) {
        const { detail } = e;
        const { selections } = detail;
        const { name } = selections[0];
        this.handleSportSelected(name);
    }

    handleSportSelected(sport) {}
}
